import service from '..';

// 全科均分统计
export const getAllCourseAvg = (examId : ID) =>
  service.get<AllCourseAvgStat>('/teacher/exam/statistic/wholecourse/avg', {examId});

// 全科分段同级
export const getAllCourseSplit = (examId: ID, scoreGroupStep: ID) =>
  service.get<AllCourseSplit>('/teacher/exam/statistic/wholecourse/scoregroupcount', {examId, scoreGroupStep});

// 单科分段同级
export const getSingleCourseAnalysis = (params: GetSingleCourseAnalysisParams) =>
  service.get<SingleCourseAnalysis>('/teacher/exam/statistic/singlecourse/scoregroupcount', params);

// 四率同级
export const getFourRatesAnalysis = (params: Omit<GetSingleCourseAnalysisParams, 'scoreGroupStep'>) =>
  service.get<FourRateAnalysis>('/teacher/exam/statistic/singlecourse/fourrate', params);

// 发布设置-获取发布设置
export const getPublishConfig = (examId: ID) =>
  service.get<PublishData>(`/teacher/mana/exam/${examId}/publish/config`);

// 导出小题得分明细
export const exportCourseScoreZip = (examId: ID) =>
  service.get<ExportCourseScore>('/teacher/exam/schoolcoursescore/attach/zipurl', { examId });

// 添加日志
export const addLogoPt = (examId: ID, excelFileName: string) =>
  service.post<boolean>('/teacher/mana/logopt', {examId, excelFileName});
